import * as React from 'react'

import { css, Global, useTheme } from '@emotion/react'
import convert from 'color-convert'

import colors, { Colors } from '../theme/colors'
import { dropShadows } from '../theme/dropShadows'

export default () => {
  const theme = useTheme()
  return (
    <Global
      styles={css`
        :root {
          ${Object.keys(colors).map(key => {
            const color = key as Colors
            return `--mooncake-color-${key}: ${theme.colors[color]}; --mooncake-color-${key}-rgb: ${convert.hex.rgb(
              theme.colors[color]
            )}`
          })}
          ${Object.keys(dropShadows).map(key => {
            const value = key as keyof typeof dropShadows
            return `--mooncake-dropShadow-${key}: ${theme.dropShadows[value]};`
          })}
        }
      `}
    />
  )
}
